import { createContext } from 'react';
export const retentionModalDefaultConfig = {
    delayInSeconds: 30,
    title: 'Unlock a Secret Gift from Santa',
    copy: 'Drop your email below to receive your exclusive Christmas surprise!',
    inputText: 'Enter your email',
    smallPrint: '<p>By entering....</p>',
    buttonText: 'Get gift!',
    successButtonText: 'Done!',
    background: {
        src: '',
        alt: '',
    },
    loggedIn: false,
};
export const RetentionModalCTX = createContext(retentionModalDefaultConfig);
